export const getActivityActor = (account) => {
  const email = account?.username?.trim().toLowerCase() || "";
  return {
    actorEmail: email,
    actorName: account?.name || email || "System",
  };
};
